import Reveal from '@/components/base/Reveal';
import { communityUrl } from '@/mocks/strategix';

export default function AdCabinetScreenshots() {
  return (
    <section className="relative w-full px-5 md:px-10 pb-20 md:pb-28">
      <div className="max-w-4xl mx-auto">
        <Reveal>
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-5 p-6 md:p-8 rounded-lg border border-accent-500/40 bg-accent-500/10">
            <span className="w-12 h-12 flex-none flex items-center justify-center rounded-md bg-accent-500/20 text-accent-300">
              <i className="ri-gallery-line text-2xl"></i>
            </span>
            <div className="flex-1">
              <h2 className="font-heading text-base md:text-lg text-foreground-950">Скрины из рекламного кабинета</h2>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                Вы можете запросить их у менеджера или написать в наше сообщество.
              </p>
            </div>
            <a
              href={communityUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-full lg:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-vk-line text-base"></i>
              Написать в сообщество
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}